import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtPostStoreList(params) {
  return request(
    `${BASE_URL}/provider/ams/store/list`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostStoreQuery(params) {
  return request(
    `${BASE_URL}/provider/ams/store/query`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostStoreQueryCount(params) {
  return request(
    `${BASE_URL}/provider/ams/store/query/count`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostStore(params) {
  return request(
    `${BASE_URL}/provider/ams/store`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtGetStore(params) {
  return request(`${BASE_URL}/provider/ams/store/${params}`, METHOD.GET, params)
}

export async function rqtPutStore(params) {
  return request(
    `${BASE_URL}/provider/ams/store`,
    METHOD.PUT_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostStoreAuditAgree(params) {
  return request(
    `${BASE_URL}/provider/ams/store/${params.id}/audit/agree`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}

export async function rqtPostStoreAuditReject(params) {
  return request(
    `${BASE_URL}/provider/ams/store/${params.id}/audit/reject`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
